/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Last_UpdatedInputs */

const en_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: 24 March 2026`)
};

const de_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Aktualisierung: 24. Maerz 2026`)
};

const fr_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour : mars 2026`)
};

const es_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización: marzo 2026`)
};

const it_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento: marzo 2026`)
};

const nl_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst bijgewerkt: maart 2026`)
};

const pl_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktualizacja: marzec 2026`)
};

const fi_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi päivitetty: maaliskuu 2026`)
};

const da_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidst opdateret: marts 2026`)
};

const sv_privacy_last_updated = /** @type {(inputs: Privacy_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast uppdaterad: mars 2026`)
};

/**
* | output |
* | --- |
* | "Last updated: 24 March 2026" |
*
* @param {Privacy_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_last_updated = /** @type {((inputs?: Privacy_Last_UpdatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Last_UpdatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_last_updated(inputs)
	if (locale === "fr") return fr_privacy_last_updated(inputs)
	if (locale === "es") return es_privacy_last_updated(inputs)
	if (locale === "it") return it_privacy_last_updated(inputs)
	if (locale === "nl") return nl_privacy_last_updated(inputs)
	if (locale === "pl") return pl_privacy_last_updated(inputs)
	if (locale === "fi") return fi_privacy_last_updated(inputs)
	if (locale === "da") return da_privacy_last_updated(inputs)
	if (locale === "sv") return sv_privacy_last_updated(inputs)
	return en_privacy_last_updated(inputs)
});